export default {
  // TODO inserir  antes de cada URL
  verifyExistsProgrammingSlaughter: {
    method: "get",
    url: "programacao-abate/verifica-existe-programacao/"
  },
  insertProgrammingSlaughter: {
    method: "post",
    url: "programacao-abate/"
  },
  updateProgrammingSlaughter: {
    method: "put",
    url: "programacao-abate/{id}/troca-data-abate/"
  },
  loadProgramacaoAbate: {
    method: "get",
    url: "programacao-abate/{id}"
  },
  loadProgrammingSlaughterDemands: {
    method: "get",
    url: "programacao-abate-demanda/"
  },
  insertDemanda: { method: "post", url: "programacao-abate-demanda/" },
  updateDemanda: {
    method: "put",
    url: "programacao-abate-demanda/{id}"
  },
  insertDemandaBatch: { method: "post", url: "programacao-abate-demanda/batch-insert/" },
  updateDemandaBatch: {
    method: "put",
    url: "programacao-abate-demanda/batch-update/"
  },
  loadBatchsAvaliable: {
    method: "get",
    url: "programacao-abate/{cdProgramacaoAbate}/lotes-indicados-abate/{cdPlantaAbate}/"
  },
  loadBatchsAllocated:  {
    method: "get",
    url: "programacao-abate-alocado/"
  },
  insertSlaughterProgrammingAllocatedLots: {
    method: "post",
    url: "programacao-abate-alocado/batch-insert/"
  },
  updateSlaughterProgrammingAllocatedLots: {
    method: "put",
    url: "programacao-abate-alocado/batch-update/"
  },
  deleteSlaughterProgrammingAllocatedLots: {
    method: "delete",
    url: "programacao-abate-alocado/batch-delete/"
  },
  loadSlaughterPlantEstablishment: {
    method: "get",
    url: "planta-abate-estabelecimento/"
  },
  changeStatusProgramacao: {
    method: "post",
    url: "programacao-abate/atualiza-status/"
  },
  loadDistanciaPlantaAbateEstabelecimento: {
    method: "get",
    url: "planta-abate-estabelecimento/"
  },
  updateProgramacaoAbateAlocado: {
    method: "put",
    url: "programacao-abate-alocado/{id}"
  },
  deleteProgramacaoAbateAlocado: {
    method: "delete",
    url: "programacao-abate-alocado/{id}"
  },
  loadCheckListProgramacaoAbateAlocado: {
    method: "get",
    url: "checklist-abate/"
  },
  updateCheckListCarregamento: {
    method: "put",
    url: "checklist-abate/{id}/preenche-periodo-carregamento/"
  },
  updateCheckListAbate: {
    method: "put",
    url: "checklist-abate/{id}/preenche-periodo-abate/"
  }
};
